// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3qLmz","right":"Layout_right__3L-z3"};